import React from "react";
import { Header } from "./components/Header";
import { BottomNav } from "./components/BottomNav";
import { TakebacksTable } from "./components/TakebacksTable";
import { DropStoreModeToggle } from "./components/DropStoreModeToggle";
export const Alerts = ({ onBack, onInventoryClick, onRowClick }) => {
  const filter = {
    product_id: { eq: "lego-bricks" },
    customer_id: {
      contains: "",
    },
    data: {
      contains: "rejectCategory",
    },
  };

  // Generate a unique key for each mount to force table remount and data refresh
  const [mountTime] = React.useState(Date.now());
  const tableKey = `alerts-${mountTime}`;

  // Remove the query cache invalidation - we'll handle this differently

  return (
    <div className="min-h-screen bg-[#030711] text-white flex flex-col">
      <Header
        showModal={false}
        onExit={onBack}
        showLogIssueIcon={true}
        showUserIcon={true}
      >
        <div className="flex justify-between items-center w-full">
          <div className="w-10"></div>
          <div className="text-center text-2xl font-bold">Alerts</div>
          <div className="mr-2">
            <DropStoreModeToggle />
          </div>
        </div>
      </Header>

      <TakebacksTable
        key={tableKey}
        refreshKey={mountTime}
        filter={filter}
        emptyStateTitle="No alerts"
        emptyStateMessage="When packages are rejected, they will display here"
        showStatusColumn={true}
        tableType="alerts"
        onRowClick={onRowClick}
      />

      <BottomNav
        activeTab="alerts"
        onProcessingClick={onBack}
        onAlertsClick={() => {}}
        onInventoryClick={onInventoryClick}
      />
    </div>
  );
};
